import { DTYPES } from "./constants";

const SOURCE_ID = "enverus_rigs";
const LAYER_ID = "enverus_rigs";
const BORDER_HIGHLIGHT_LAYER_ID = "enverus_rigs_highlight";
const FILTER_LAYER_IDS = [LAYER_ID];
const CLICKABLE_LAYERS = [LAYER_ID];
const UNIQUE_COLUMN = "id";

const API_BASE_ENDPOINT = "enverus-rigs";
const TILE_ENDPOINT = `${
  process.env.REACT_APP_SERVER_URL
}/api/${API_BASE_ENDPOINT}/tiles/{z}/{x}/{y}.pbf?access_token=${localStorage.getItem(
  "authToken"
)}`;

const INITIAL_FILTER_STATE = {
  state: {
    column: "state",
    label: "State",
    dtype: DTYPES.STRING,
    value: [],
    excludeSelected: false,
    excludeNullValues: false,
  },
  county: {
    column: "county",
    label: "County",
    dtype: DTYPES.STRING,
    value: [],
    excludeSelected: false,
    excludeNullValues: false,
  },
  "operator.name": {
    column: "operator.name",
    label: "Operator",
    dtype: DTYPES.STRING,
    value: [],
    excludeSelected: false,
    excludeNullValues: false,
  },
};

const EXPORT_COLUMNS = [
  { key: "id", label: "ID" },
  { key: "api_uwi_10", label: "API 10" },
  { key: "api_uwi_14", label: "API 14" },
  { key: "rrc_id", label: "RRC ID" },
  { key: "rig_name_number", label: "Name / Number" },
  { key: "lease_name", label: "Lease Name" },
  { key: "operator.name", label: "Operator" },
  { key: "contractor", label: "Contractor" },
  { key: "rig_type", label: "Type" },
  { key: "state", label: "State" },
  { key: "county", label: "County" },
  { key: "spud_date", label: "Spud Date", type: "date", format: "YYYY-MM-DD" },
  {
    key: "first_date",
    label: "First Date",
    type: "date",
    format: "YYYY-MM-DD",
  },
  { key: "last_date", label: "Last Date", type: "date", format: "YYYY-MM-DD" },
  {
    key: "drilling_end_date",
    label: "Drilling End Date",
    type: "date",
    format: "YYYY-MM-DD",
  },
  {
    key: "release_date",
    label: "Release Date",
    type: "date",
    format: "YYYY-MM-DD",
  },
];

const ADD_AFTER = "Bottoms";

const getLayerAfter = (map, layerId) => {
  const layers = map.getStyle().layers;
  const idx = layers.findIndex((l) => l.id === layerId);
  if (idx !== -1 && idx + 1 < layers.length) {
    return layers[idx + 1].id;
  }
  return undefined;
};

const addSource = (mapRef) => {
  if (!mapRef.current.getSource(SOURCE_ID)) {
    mapRef.current.addSource(SOURCE_ID, {
      type: "vector",
      tiles: [TILE_ENDPOINT],
      minzoom: 0,
      maxzoom: 14,
    });
  }
};

const addLayers = (mapRef) => {
  const map = mapRef.current;
  const addBefore = getLayerAfter(map, ADD_AFTER);

  if (!map.getLayer(LAYER_ID)) {
    map.addLayer(
      {
        id: LAYER_ID,
        type: "symbol",
        source: SOURCE_ID,
        "source-layer": SOURCE_ID,
        layout: {
          visibility: "visible",
          "icon-image": "rig",
          "icon-size": ["step", ["zoom"], 0.15, 10, 0.25, 12, 0.35],
          "icon-allow-overlap": true,
        },
      },
      addBefore
    );
  }

  if (!map.getLayer(BORDER_HIGHLIGHT_LAYER_ID)) {
    map.addLayer(
      {
        id: BORDER_HIGHLIGHT_LAYER_ID,
        type: "symbol",
        source: SOURCE_ID,
        "source-layer": SOURCE_ID,
        layout: {
          "icon-image": "rig",
          "icon-size": ["step", ["zoom"], 0.15, 10, 0.25, 12, 0.35],
          "icon-allow-overlap": true,
        },
        filter: ["==", UNIQUE_COLUMN, -1],
      },
      addBefore
    );
  }
};

const addAll = (mapRef) => {
  addSource(mapRef);
  addLayers(mapRef);
};

export {
  EXPORT_COLUMNS,
  SOURCE_ID,
  LAYER_ID,
  BORDER_HIGHLIGHT_LAYER_ID,
  FILTER_LAYER_IDS,
  CLICKABLE_LAYERS,
  UNIQUE_COLUMN,
  API_BASE_ENDPOINT,
  TILE_ENDPOINT,
  INITIAL_FILTER_STATE,
  addAll,
};
